import React from "react";
import NavBar from "./Components/Navbar/Navbar"; 
import Footer from "./Components/Footer/Footer";
// import Homebanner from "./Components/HomeBanner/HomeBanner";
import AboutUs from "./Components/About/About";
import StorySection from "./Components/StorySection/StorySection";
import MilkSection from "./Components/MilkSection/MilkSection";
// import MilkDelievery from "./Components/MilkDelivery/MilkDelivery";
import FloatingButtons from "./Components/FloatingButtons/FloatingButtons";
import HeroSlider from "./Components/HeroSlider/HeroSlider";
import WhyChooseUs from "./Components/ChooseUs/WhyChooseUs";
import Services from "./Components/Service/Services";
import MobileImageCarousel from "./Components/CarouselMobile/MobileImageCarousel";
import Enquiry from "./Components/Enquiry/Enquiry";
// import Process from "./Components/Process/Process";
// import ContactUs from "./Components/ContactUs/ContactUs";
// import ProcessSection from "./Components/Process/Process";
// import Vision from "./Components/Vision/Vision";
// import Vision from ".Components/Vision/Vision";

// import Product from "./Components/Product/Product";
// import ProductDetail from "./Components/ProductDetail/ProductDetail";
// import Service from "./Components/Service/Service";
// import ProductsDetails from "./Components/ProductsDetails/ProductsDetails";
// import Gallery from "./Components/Gallery/Gallery";

function App() {
  return (
    <>
      <NavBar/>
      <FloatingButtons />
    <div style={{ backgroundColor: "#354344", color: "#fff" }}>
      <HeroSlider />
      <AboutUs />
      <StorySection />
      <MilkSection />
      {/* <MilkDelievery /> */}
      <MobileImageCarousel />
      <WhyChooseUs />
      <Services />
      <Enquiry />
      {/* <Process /> */}
      {/* <Homebanner /> */}
      {/* <Vision /> */}
      {/* <NavBar />} */}
      {/* <Service /> */}
      {/* <ProductDetail /> */}
      {/* <ProductsDetails /> */}
      {/* <Product /> */}
      {/* <Gallery /> */}
      {/* <ContactUs /> */}
      
    </div>
      <Footer /> 
      </>
  );
}

export default App;
